import DOMPurify from 'dompurify';

interface Props {
  html?: string | null;
}

/** Renders campaign-authored rich HTML (topCopy) — sanitized defense-in-depth. */
export default function RichTopCopy({ html }: Props) {
  if (!html) return null;
  return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
}
